module.exports = __webpack_public_path__ + "img/group126.c4ce041b.png";